import Component from '../../shared/component';

export default class ReloadPageLink extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('click.reloadPageLink', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('click.reloadPageLink', this.handleClick);
  }

  handleClick() {
    setTimeout(() => {
      window.Turbolinks.reload({keepScrollPosition: true});
    }, 100);
  }
}
